<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" crossorigin="anonymous" referrerpolicy="no-referrer" />
<div [ngSwitch]="header" style=" padding : 0px 0px 0px  0px">
  <div *ngSwitchCase="'1'" style=" padding : 0px 0px 0px  0px">

    <div class=" row d-flex justify-content-center align-content-center" style="margin-bottom: -10px">
      <div class="col-3 p-2" (click)="addNewItem('Allstatus')" id="Data"> {{MainHeader}}<br /> <hr /> <br /> Total Count:&nbsp;&nbsp; <b class="blue-color"><u>{{totalStatus}}</u></b></div>

      <div class=" col-4 info-box  shadow-sm " id="main" style="margin-bottom: 08px">
        <span class="info-box-icon bg-gradient-primary elevation-1 img-size">
          <i class="fa fa-cog  fa-sm" aria-hidden="true"></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader1}}</span>
          <span class="info-box-number" (click)="addNewItem('Inprocess')"><u>{{value1}}</u></span>
        </div>
      </div>
      <div class="col-4 info-box" id="main" style="margin-bottom: 08px">
        <span class="info-box-icon bg-gradient-olive elevation-1 img-size">
          <i class="fa fa-reply" aria-hidden="true"></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader2}}</span>
          <span class="info-box-number" (click)="addNewItem('Response')"><u>{{value2}}</u></span>
        </div>
      </div>

    </div>
  </div>
  <div *ngSwitchCase="'2'" style=" padding : 0px 0px 0px  0px">
    <div class="d-flex justify-content-center align-content-center" style="margin-bottom: -10px">
      <div class="col-3 p-2" (click)="addNewItem1('Response')" id="Data"> {{MainHeader}}<br /> <hr /> <br /> Total Count:&nbsp;&nbsp;<b class="blue-color"><u>{{totalRCAStatus}}</u></b></div>
      <div class=" col-3 info-box " id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class="fa-solid fa-gauge-high red-color" aria-hidden="true"></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader1}}</span>
          <span class="info-box-number" (click)="addNewItem1('Root Cause')"><u>{{value1}}</u></span>
        </div>
      </div>

      <div class=" col-3 info-box " id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class='fa-solid fa-gauge yellow-color' aria-hidden="true"></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader2}}</span>
          <span class="info-box-number" (click)="addNewItem1('Preventive Action')"><u>{{value2}}</u></span>
        </div>
      </div>

      <div class=" col-3 info-box" id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class='fas fa-tachometer-alt green-color'></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader3}}</span>
          <span class="info-box-number" (click)="addNewItem1('Corrective Action')"><u>{{value3}}</u></span>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'3'" style=" padding : 0px 0px 0px  0px">
    <div class="d-flex justify-content-center align-content-center" style="margin-bottom: -10px">
      <div class="col-4 p-2" (click)="addNewItem2('AllOverdue')" id="Data"> {{MainHeader}} <br /> <hr /> <br /> Total Count:&nbsp;&nbsp; <b class="blue-color"><u>{{totaloverdue}}</u></b></div>
      <div class="col-3 info-box " id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class='fa-solid fa-calendar-days orangered-color' aria-hidden="true"></i>
        </span>
        <div class="info-box-content text-center  align-content-start">
          <span class="info-box-text">{{cardheader1}} </span>
          <span class="info-box-number" (click)="addNewItem2('OverDue')"><u>{{value1}}</u></span>
        </div>
      </div>
      <div class=" col-3 info-box " id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class='fa fa-calendar yellow-color'></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader2}}</span>
          <span class="info-box-number" (click)="addNewItem2('OnDue')"><u>{{value2}}</u></span>
        </div>
      </div>
      <div class=" col-3 info-box " id="main">
        <span class="info-box-icon bg-gradient-light elevation-1 img-size">
          <i class='fa fa-calendar orangered-color'></i>
        </span>
        <div class="info-box-content text-center">
          <span class="info-box-text">{{cardheader3}}</span>
          <span class="info-box-number" (click)="addNewItem2('DueFor')"><u>{{value3}}</u></span>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchDefault> </div>
</div>
